<div
  class="multiselect-dropdown-container"
  [ngClass]="dropdownWidthClass"
>
  <ion-item-group>
    <ion-item lines="none">
      <ion-checkbox
        slot="start"
        [(ngModel)]="checkAllIds"
        (click)="selectAllCheckboxesEvent()"
      ></ion-checkbox>
      <ion-label>{{ SELECT_ALL_TEXT }}</ion-label>
    </ion-item>
    @for (result of searchResults; track result) {
      <ion-item lines="none">
        <ion-checkbox
          slot="start"
          [(ngModel)]="result.selected"
          (ionChange)="statusChangeForDropdownEvent()"
        >
        </ion-checkbox>
        <ion-label>{{ result.id }}</ion-label>
      </ion-item>
    }
  </ion-item-group>
</div>
